import { auth } from './firebase/firebase.js';

export const unathorizedRoute = "index.html";
export const authorizedRoute = "booking-management.html";

export const checkAuth = () => {
    auth.onAuthStateChanged(async (user) => {
        if (user) {
            let claims = (await user.getIdTokenResult()).claims;
            if (!claims.admin && !claims.staff) {
                document.querySelector(".nk-content").hidden = true;
                window.location.href = unathorizedRoute;
            }
            else {
                document.querySelector(".nk-content").hidden = false;

                if (claims.staff) {
                    let staffForbiddenRoutes = ["service-category-management.html", "vehicle-management.html", "advertisement-management.html", "staff-management.html"].map(element => "/admin/"+element);
                    let url = new URL(window.location.href);
                    if(staffForbiddenRoutes.includes(url.pathname)){
                        window.location.href = "booking-management.html";
                    }
                }
            }
        }
        else {
            document.querySelector(".nk-content").hidden = true;
            window.location.href = unathorizedRoute;
        }
    })
}

export const checkIfLoggedIn = () => {
    if (sessionStorage.loggedIn == "true") {
        window.location.href = authorizedRoute;
    }
}

export const addLogout = () => {
    let logoutButton = document.getElementById("logout");
    logoutButton.addEventListener("click", async (e) => {
        e.preventDefault();
        await auth.signOut();
        sessionStorage.clear();
        window.location.href = unathorizedRoute;
    });

}




